import * as types from "../Actions/actionTypes";
import { ApiError, ApiErrorData } from "../../sharedTypes";

export const apiErrorInitialState = {
    apiError: null as any,
} as ApiErrorData;

export default function apiErrorReducer(state = apiErrorInitialState.apiError, action: any): ApiError {
    switch (action.type) {
        case types.API_ERROR_OCCURRED:
            return action.error as ApiError;
        default:
            if (!state) {
                return {
                    isOccurring: false,
                    endUserErrorMessage: null,
                    internalErrorMessage: null,
                    errorType: null,
                } as ApiError;
            }
    }

    return state;
}
